import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { LuPlus } from "react-icons/lu";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import callOpenAIAPI from "../../utils/openAI.js";
import { useLocation } from 'react-router-dom';
import {
    editRisk,
    editAction,
    editControl,
    createComplianceRisk,
    resetError,
    getComplianceRisks,
    openOverlay,
    closeOverlay,
    resetNewlyCreatedComplianceRiskId,
    setCurrentPageRedux,
    resetChangedPageSize,
    setPageSizeRedux,
    resetSortedTriggered
} from "../../store/actions/riskActions.js";
import { getComplianceStandardsByCompany} from "../../store/actions/complianceActions.js";
import { Redirect, useHistory } from "react-router-dom";

import LOADER from "../../assets/images/loader.svg";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import DraggableControlCard from "../../components/Risk/DraggableControlCard.js";
import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import RiskDetailsForm from "../../components/Risk/RiskOverlay";
import RiskTable from "../../components/Risk/RiskTable";
import ActionOverlay from "../../components/Action/ActionOverlay";
import ControlOverlay from "../../components/Control/ControlOverlay";
import IncidentDetailsForm from "../../components/Incidents/IncidentOverlay";
import { NotificationContainer } from "react-notifications";
import { FiAlertTriangle, FiXCircle, FiClock, FiCheckCircle } from "react-icons/fi";



function ComplianceRisk(props) {
    const { t } = useTranslation();
    const {
        editRiskFN,
        getComplianceStandardsByCompanyFN,
        editActionFN,
        editControlFN,
        token,
        go_to_risk_dashboard,
        gotoIncident,
        complianceRisks,
        createComplianceRiskFN,
        resetErrorFN,
        getComplianceRisksFN,
        isOverlayOpen,
        closeOverlayFN,
        totalPages,
        currentPage,
        pageSize,
        activeComplianceStandardId,
        newlyCreatedComplianceRiskId,
        resetNewlyCreatedComplianceRiskIdFN,
        profile,
        setCurrentPageReduxFN,
        resetChangedPageSizeFN,
        changed_page_size,
        setPageSizeReduxFN,
        sortBy,
        sorted_triggered,
        resetSortedTriggeredFN,
        id
    } = props;

    ////////console.log("pageSize:", pageSize);
    ////////console.log("activeComplianceStandardID", activeComplianceStandardId);
    const history = useHistory();

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [risk_id, setRiskId] = useState(null);
    const [isActionOpen, setIsActionOpen] = useState(false);
    const [action_id, setActionId] = useState(null);
    const [isControlOpen, setIsControlOpen] = useState(false);
    const [control_id, setControlId] = useState(null);
    const [isIncidentOpen, setIsIncidentOpen] = useState(false);

     const location = useLocation();

    const getCurrentPageName = () => {
        const path =location.pathname; 
        const lastSegment = path.split("/").filter(Boolean).pop() || "";
        return lastSegment.replace(/_/g, " ");
    };


    // State to store AI-suggested controls
    const [controls, setControls] = useState([]);
    const [loadingAI, setLoadingAI] = useState(false); // For loading state during API call
    const [showControls, setShowControls] = useState(false);

     const onRemoveControl = (id) => {
        setControls(prevControls => prevControls.filter(c => c.id !== id));
    };

    // Fetch compliance risks when the page loads
    useEffect(() => {
        setPageSizeReduxFN(10);
        ////////console.log("activeCompliancwStandardID inside useEffect:", activeComplianceStandardId);
        if (profile && profile.role === "Admin") {
            getComplianceRisksFN(1, 10, activeComplianceStandardId, sortBy);
        }
    }, [activeComplianceStandardId]);

    useEffect(() => {
        //////console.log("page", changed_page_size, pageSize);
        if (changed_page_size) {
            resetChangedPageSizeFN();
            setCurrentPageReduxFN(1);
            getComplianceRisksFN(1, pageSize, activeComplianceStandardId, sortBy);   
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changed_page_size]);

    useEffect(() => {
        //////console.log('sorted triggered"');
        if (sorted_triggered) {
            resetSortedTriggeredFN();
            ////////console.log("sortBy was changed 2", sorted_triggered);
            if (profile && (profile.role === "Admin" || profile.role === "Auditor")) {
                getComplianceRisksFN(currentPage, pageSize, activeComplianceStandardId, sortBy);
            }
            else {
                getComplianceRisksFN(currentPage, pageSize, activeComplianceStandardId, sortBy);
            }


        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sorted_triggered]);

    // Handle newly created compliance risks
    useEffect(() => {
        //////console.log(newlyCreatedComplianceRiskId);
        if (newlyCreatedComplianceRiskId) {
            resetNewlyCreatedComplianceRiskIdFN();
            setRiskId(newlyCreatedComplianceRiskId);
            history.push("/risk_overview/" + newlyCreatedComplianceRiskId, { from: getCurrentPageName() });
            //setIsPopupOpen(true);

        }
    }, [newlyCreatedComplianceRiskId]);

        useEffect(() => {
                ////console.log("isOverlayOpen", isOverlayOpen, ": " ,id)
                if (isOverlayOpen && id) {
                    setRiskId(id);
                    history.push("/risk_overview/" + id, { from: getCurrentPageName() });
                }
            }, [isOverlayOpen, id]);

    // Handle changes in compliance risks
    useEffect(() => {
        ////////console.log("comploanceRisks", complianceRisks);
        if (complianceRisks) {
            setData(complianceRisks);
        }
    }, [complianceRisks]);


    useEffect(() => {
            if (go_to_risk_dashboard) {
                history.push({ pathname: `/dashboards/${go_to_risk_dashboard}` });
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [go_to_risk_dashboard]);


    useEffect(() => {
        if (gotoIncident) {
            // setIsIncidentOpen(true);
            history.push({ pathname: `/incidents/${gotoIncident}` });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gotoIncident]);
    // Handle errors
    useEffect(() => {
        if (props.error) {
            setLoading(false);
            resetErrorFN();
        }
    }, [props.error, resetErrorFN]);

    // Close the compliance risk creation popup
    const closeCreation = async (data, risk_id) => {
        ////console.log("Closong overlay")
        getComplianceRisksFN(1, 10, activeComplianceStandardId, sortBy);
        await updateRiskServerData(data, risk_id)
        await closeOverlayFN();
        setIsPopupOpen(false);
        

    };

    const closeIncident = () => {
        ////////console.log("closeIncident")
        setIsIncidentOpen(false);

    }


    const updateRiskServerData = async (data, risk_id) => {
        ////console.log("Update data", data)
        setLoading(true);
        await editRiskFN(risk_id, data);
        setLoading(false);
    }

    // Close the control overlay
   
    const closeControl = async(data, control_id) => {
        ////console.log("closeControl")
        setIsControlOpen(false);
        await updateControlServerData(data, control_id)
    }


    const closeAction = async (data, action_id) => {
        ////////console.log("closeAction")
        setIsActionOpen(false);
        await updateActionServerData(data, action_id)

    }

     const updateControlServerData = async (data, control_id) => {

        const updatedData = { ...data };

            // Add one day to StartDate and EndDate if they exist
            if (updatedData.StartDate) {
                const startDate = new Date(updatedData.StartDate);
                startDate.setDate(startDate.getDate());
                updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
            }

            if (updatedData.EndDate) {
                const endDate = new Date(updatedData.EndDate);
                endDate.setDate(endDate.getDate());
                updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
            }

            //////console.log("CONTROL DATA AFTER ADJUSTMENT", updatedData);

            setLoading(true);
            await editControlFN(risk_id, control_id, updatedData);
            setLoading(false);
    }


    const updateActionServerData = async (data, action_id) => {

        //////console.log("ACTION DATA BEFORE ADJUSTMENT", data);

        // Clone data to avoid modifying state directly
        ////console.log("Action:", data, "action_id:", action_id)
        const updatedData = { ...data };

        // Add one day to StartDate and EndDate if they exist
        if (updatedData.StartDate) {
            const startDate = new Date(updatedData.StartDate);
            startDate.setDate(startDate.getDate() + 1);
            updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        if (updatedData.EndDate) {
            const endDate = new Date(updatedData.EndDate);
            endDate.setDate(endDate.getDate() + 1);
            updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        //////console.log("ACTION DATA AFTER ADJUSTMENT", updatedData);

        setLoading(true);
        editActionFN(risk_id, action_id, updatedData);
        setLoading(false);
    }

    const fetchAISuggestions = async (title, details) => {
        setShowControls(false);
        setLoadingAI(true); // Show loading indicator
        ////////console.log("loadingAI set to true");
        try {
            // Call the backend API for the `suggestControl` use case
            const aiResponse = await callOpenAIAPI( title, details );
            ////console.log("aiResponse1",aiResponse)
            const parsedControls = aiResponse.map((control, i) => ({
                ...control,
                id: crypto.randomUUID?.() || `control-${i}`,
            }));
            setControls(parsedControls);

            ////console.log("aiResponse",parsedControls)
            // Introduce a delay before showing controls
            setTimeout(() => {
                setShowControls(true); // Trigger animation
            }, 300); // 300ms delay for animation

        } catch (error) {
            console.error("Error fetching AI suggestions:", error);
        } finally {
            setLoadingAI(false); // Hide loading indicator
            ////////console.log("loadingAI set to false");
            ////////console.log("AI CONTROLS: ", controls);
        }
    };


    const [searchTerm, setSearchTerm] = useState("");
    



    const flattenedRisks = useMemo(() => {
        const list = Array.isArray(data) ? data : [];
        const q = (searchTerm || "").trim().toLowerCase();

        if (!q) return list;

        const includes = (v) =>
            (v ?? "").toString().toLowerCase().includes(q);

        return list.filter((r) => {
            const id = r.ID;
            const title = r.Title;
            const status = r.Status;
            const ownerFull = `${r.OwnerFirstName ?? ""} ${r.OwnerLastName ?? ""}`.trim();

            return (
                includes(id) ||
                includes(`r-${id}`) ||
                includes(title) ||
                includes(status) ||
                includes(ownerFull)
            );
        });
    }, [data, searchTerm]);


     function StatCard({ cardKey, label, value }) {
            let Icon;
            let iconColor = "text-gray-400";
    
            switch (cardKey) {
                case "total":
                    Icon = FiAlertTriangle;
                    iconColor = "text-gray-500";
                    break;
                case "open":
                    Icon = FiClock;
                    iconColor = "text-blue-500";
                    break;
                case "inProgress":
                    Icon = FiXCircle;
                    iconColor = "text-orange-500";
                    break;
                case "closed":
                    Icon = FiCheckCircle;
                    iconColor = "text-green-500";
                    break;
                default:
                    Icon = null;
            }
    
            return (
                <div className="rounded-xl border border-gray-200 bg-white p-4 flex flex-col justify-between">
                    <div className="flex items-center justify-between">
                        <div className="text-xs text-gray-500">{label}</div>
                        {Icon && <Icon className={`w-4 h-4 ${iconColor}`} />}
                    </div>
                    <div className="mt-1 text-2xl text-[#0E0E0E]">
                        {value ?? 0}
                    </div>
                </div>
            );
        }
    
        const counts = useMemo(() => {
            const norm = (s = "") => s?.toString().trim().toLowerCase();
    
            let total = flattenedRisks?.length || 0;
            let open = 0;
            let inProgress = 0;
            let closed = 0;
    
            (flattenedRisks || []).forEach((r) => {
                const status = norm(r.Status);
    
                if (status === "open") open++;
                if (status === "in progress") inProgress++;
                if (status === "closed") closed++;
            });
    
            return { total, open, inProgress, closed };
        }, [flattenedRisks]);

    //////console.log("currentPage:", currentPage);
    return token && activeComplianceStandardId ? (
    <div className="flex flex-col w-full h-screen overflow-auto p-4 pb-16">

  {/* Sticky top bar */}
   <div className="top-0 z-30 bg-white">
    {/* Stat Cards */}
<div className="mt-4 pb-4">
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
    <StatCard cardKey="total" label={t("riskTable.summary.totalRisks")} value={counts.total} />
    <StatCard cardKey="open" label={t("riskTable.summary.open")} value={counts.open} />
    <StatCard cardKey="inProgress" label={t("riskTable.summary.inProgress")} value={counts.inProgress} />
    <StatCard cardKey="closed" label={t("riskTable.summary.closed")} value={counts.closed} />
  </div>
</div>
    <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
        
      <div className="flex items-center gap-2">

        {/* SEARCH */}
        <div className="relative flex-1 min-w-[260px]">
          <input
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={t("riskTable.searchCompliancePlaceholder")}
            className="
              w-full bg-[#F3F4F6] rounded-md text-xs pl-8 pr-3 py-2
              outline-none border-none
              focus:outline-none focus:ring-0 focus:border-none
              active:outline-none active:ring-0 active:border-none
            "
          />
          <svg
            className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* ACTIONS */}
        <div className="flex items-center gap-2 ml-auto">
          {profile?.role !== "Auditor" && (
            <button
              type="button"
              onClick={() => {
                createComplianceRiskFN(
                  currentPage,
                  pageSize,
                  activeComplianceStandardId,
                  sortBy
                );
              }}
              disabled={loading}
              className="
                flex items-center justify-center gap-2
                bg-[#F3F4F6] rounded-md text-xs px-3 py-2
                shadow-sm hover:shadow transition
                disabled:opacity-60 disabled:cursor-not-allowed
              "
              title={t("riskTable.addRisk")}
            >
              <LuPlus className="w-4 h-4 text-gray-700" />
              {loading ? (
                <img src={LOADER} alt="Loading..." className="w-4 h-4" />
              ) : (
                <span className="text-gray-800">{t("riskTable.addRisk")}</span>
              )}
            </button>
          )}
        </div>
      </div>

      {/* ERROR */}
      {props?.error && (
        <div className="text-red-500 text-xs italic mt-2">
          {props.error}
        </div>
      )}
    </div>
  </div>



          <div className="w-full mt-4 mb-4 tabella">
                <RiskTable data={flattenedRisks} getRisksFN={getComplianceRisksFN} totalPagesServer={totalPages} currentPage2={currentPage} pageSize2={pageSize} reduxSortBy={sortBy} mode='compliance'/>
            </div>



            <Popup
                open={isPopupOpen}
                nested
                key={risk_id || 'new'}
                //contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}
            >
                {risk_id && (
                    <RiskDetailsForm  key={risk_id || 'new'} close={closeCreation} openControl={() => setIsControlOpen(true)} openIncident={() => setIsIncidentOpen(true)} setControlId={setControlId} controlopen={isControlOpen} openAction={() => setIsActionOpen(true)} setActionId={setActionId} actionopen={isActionOpen} fetchAISuggestions={fetchAISuggestions} loadingAI={loadingAI} mode={"compliance"} />
                )}
            </Popup>


            <DndProvider backend={HTML5Backend}>

                {/* Compliance Risk Details Popup */}
                <Popup
                    open={isPopupOpen}
                    key={risk_id || 'new'}
                    contentStyle={{ overflow: "auto", maxHeight: "80vh", width: "900px", marginTop: "14vh" }}
                >
                     <RiskDetailsForm  key={risk_id || 'new'} close={closeCreation}  openControl={() => setIsControlOpen(true)}  openIncident={() => setIsIncidentOpen(true)} setControlId={setControlId} controlopen={isControlOpen} openAction={() => setIsActionOpen(true)} setActionId={setActionId} actionopen={isActionOpen} fetchAISuggestions={fetchAISuggestions} loadingAI={loadingAI} controls={controls}  mode={"compliance"}/>
                </Popup>


                {/* Floating AI Suggested Controls */}
                {controls?.length > 0 && (
                    <>
                        <div
                            className={`absolute right-6 top-28 w-[340px] bg-transparent rounded-md p-4 transition-all duration-500 ease-in-out ${showControls ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                                }`}
                            style={{
                                zIndex: 1050, // Ensure it's above the overlay
                                pointerEvents: 'auto', // Allow interactions
                            }}

                        >
                            {controls.map((control, index) => (
                                <DraggableControlCard
                                    key={control.id}
                                    control={control}
                                    onRemove={() => onRemoveControl(control.id)}
                                />
                            ))}
                        </div>
                    </>
                )}
            </DndProvider>

            {/* Control Overlay */}
            <Popup
                open={isControlOpen}
                contentStyle={{ overflow: "auto", maxHeight: "80vh", width: "900px", marginTop: "14vh" }}
            >
                <ControlOverlay key={control_id || 'new-control'} closeControl={closeControl} risk_id={risk_id} control_id={control_id} />
            </Popup>

            {/* Action Overlay */}
            <Popup
                open={isActionOpen}
                contentStyle={{ overflow: "auto", maxHeight: "80vh", width: "900px", marginTop: "14vh" }}
            >
                <ActionOverlay closeAction={closeAction} risk_id={risk_id} action_id={action_id} />
            </Popup>

            <Popup
                open={isIncidentOpen}
                onClose={closeIncident}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
            >
                <IncidentDetailsForm is_new={true} closeIncident={closeIncident} risk_id={risk_id} />
            </Popup>

            <NotificationContainer />
        </div>
    ) : (
        <Redirect to="/risk_center" />
    );
}


const mapStateToProps = (state) => {
    ////console.log("Cmlance Risks", state)
    return {
        token: state.auth.token,
        complianceRisks: state.risk.complianceRisks,
        risks: state.risk.risks,
        totalPages: Math.ceil(state.risk.complianceRisks?.length /state.risk.pageSize),
        currentPage: state.risk.currentPage,
        pageSize: state.risk.pageSize,
        isOverlayOpen: state.risk.isOverlayOpen,
        //activeComplianceStandardId: state.compliance.activeComplianceStandardId,
        gotoIncident: state.incident.gotoIncident,
        newlyCreatedComplianceRiskId: state.risk.newlyCreatedComplianceRiskId,
        profile: state.profile.profile,
        sortBy: state.risk.sortBy,
        changed_page_size: state.risk.changed_page_size,
        sorted_triggered: state.risk.sorted_triggered,
        id: state.risk.id,
        go_to_risk_dashboard: state.risk.go_to_risk_dashboard,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createComplianceRiskFN: (currentPage, pageSize, complianceStandardId, sortBy) =>
            dispatch(createComplianceRisk(currentPage, pageSize, complianceStandardId, sortBy)),
        resetErrorFN: () => dispatch(resetError()),
        getComplianceRisksFN: (currentPage, pageSize, complianceStandardId, sortBy) =>
            dispatch(getComplianceRisks(1, 100, complianceStandardId, sortBy)),
        closeOverlayFN: () => dispatch(closeOverlay()),
        resetNewlyCreatedComplianceRiskIdFN: () => dispatch(resetNewlyCreatedComplianceRiskId()),
        setCurrentPageReduxFN: (page) => dispatch(setCurrentPageRedux(page)),
        resetChangedPageSizeFN: () => dispatch(resetChangedPageSize()),
        resetSortedTriggeredFN: () => dispatch(resetSortedTriggered()),
        setPageSizeReduxFN: (size) => dispatch(setPageSizeRedux(size)),
        editRiskFN: (risk_id, risk) => dispatch(editRisk(risk_id, risk)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),
        getComplianceStandardsByCompanyFN: () => dispatch(getComplianceStandardsByCompany()),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceRisk);